export default __webpack_public_path__ + "static/media/seafreight40ft.418dc4e5.svg";